
import MusicSquare from "../../../assets/duotone/MusicSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MusicSquareIcon({ className, dataTestid = "MusicSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MusicSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
